import { createAction, props } from '@ngrx/store';
import { Country } from '../Clubs/clubs.model';
import { Category, Club, Dossier } from './dossier.model';
import { Seasons } from '../Seasons/seasons.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records dossier'
);

export const fetchRecordsSuccess = createAction(
    '[Data] fetch records dossier success', 
    props<{ listData: Dossier[], total: number }>()
);

export const fetchRecordsFail = createAction(
    '[Data] fetch records dossier failure', 
    props<{ error: string }>()
);

//Fetch Club Speific Dossiers
export const fetchSpecificData = createAction(
    '[Data] fetch specific records dossier',
    props<{ clubId: number }>()
);

export const fetchSpecificDataSuccess = createAction(
    '[Data] fetch specific records dossier success', 
    props<{ listData: Dossier[], total: number }>()
);

export const fetchSpecificDataFail = createAction(
    '[Data] fetch specific records dossier failure', 
    props<{ error: string }>()
);


// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record dossier',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record dossier success', 
    props<{ singleData: Dossier, dossierData: {countryList: Country[], clubs: Club[], categories: Category[], seasons: Seasons[] }}>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record dossier failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record dossier',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record dossier success'
);
export const addRecordFailure = createAction(
    '[Data] Add record dossier failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record dossier',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record dossier success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record dossier failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record dossier',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record dossier success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record dossier failure',
    props<{ error: string }>()
);

// Import Records
export const importRecord = createAction(
    '[Data] Import record dossier',
    props<{ newData: any }>()
);
export const importRecordSuccess = createAction(
    '[Data] Import record dossier success'
);
export const importRecordFailure = createAction(
    '[Data] Import record dossier failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state dossier',
);